"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sjcl = require("sjcl");
function encrypt(plainText, cryptoKey) {
    var params = {
        cipher: 'aes',
        mode: 'gcm',
        ks: 256,
        ts: 128,
    };
    var ct = sjcl.encrypt(cryptoKey, plainText, params);
    var ctObj = JSON.parse(ct);
    return ctObj.iv + ctObj.ct;
}
exports.encrypt = encrypt;
function decrypt(rawCipherText, cryptoKey) {
    var ivctSeparatePos = 24;
    var cipherText = {
        cipher: 'aes',
        mode: 'gcm',
        ks: 256,
        ts: 128,
        iv: rawCipherText.slice(0, ivctSeparatePos),
        ct: rawCipherText.slice(ivctSeparatePos),
    };
    var plainText = sjcl.decrypt(cryptoKey, JSON.stringify(cipherText), {});
    return plainText;
}
exports.decrypt = decrypt;
